<template>
  <TaskTemplate class="dwp-shadow-xs dwp-bg-white dwp-px-4 dwp-py-5 dwp-rounded">
    <template #checkbox>
      <Checkbox class="dwp-block dwp-leading-normal" />
    </template>

    <template #title>
      <input
        type="text"
        @keydown.enter="$emit('submit', form)"
        @keydown.esc="$emit('cancel')"
        data-cy="edit-task-title"
        ref="title"
        class="dwp-outline-none dwp-text-gray-700 dwp-placeholder-gray-500 dwp-leading-none dwp-w-full"
        placeholder="New Task"
        v-model="thisTitle"
      />
    </template>

    <template #content>
      <Editor
        ref="content"
        data-cy="edit-task-notes"
        class="dwp-outline-none dwp-text-gray-600 dwp-text-sm dwp-leading-normal"
        placeholder="Notes"
        @keydown.esc="$emit('cancel')"
        :content.sync="thisContent"
      />
    </template>
  </TaskTemplate>
</template>

<script>
import TaskTemplate from "./templates/TaskTemplate.vue";
import Checkbox from "./Checkbox.vue";
import Editor from "./shared/Editor.vue";

export default {
  components: {
    Editor,
    Checkbox,
    TaskTemplate,
  },
  props: {
    title: String,
    content: String,
  },
  computed: {
    thisTitle: {
      get() {
        return this.title;
      },
      set(val) {
        this.$emit("update:title", val);
      },
    },
    thisContent: {
      get() {
        return this.content;
      },
      set(val) {
        this.$emit("update:content", val);
      },
    },
  },
  mounted() {
    this.$refs.title.focus();
  },
};
</script>